<div class="flash-message-container">
    <div class="flash-message alert alert-{{m.type}}" *ngFor="let m of messages; index as i">
        <a (click)="removeMessage(i)" class="close">&times;</a>
        {{m.text}}
    </div>
</div>